import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Noti } from './notification.styled';

interface NotificationContextType {
    showNotification: (message: string, type: "Success" | "Error" | "Info") => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [notifications, setNotifications] = useState<{ message: string, type: "Success" | "Error" | "Info" }[]>([]);
    const showNotification = (message: string, type: "Success" | "Error" | "Info") => {
        setNotifications([...notifications, { message, type }]);
        setTimeout(() => {
            setNotifications([]);
        }, 5000);
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {notifications.length !== 0 && (<div>
                {notifications.map((notification, index) => (
                    <Noti style={{ top: (index * 30) + (5 * index) }} key={index} className="notification">
                        <div className='icon'>
                            {notification.type === "Success" && (<SuccessIcon />)}
                            {notification.type === "Error" && <ErrorIcon />}
                            {notification.type === "Info" && <InfoIcon />}
                        </div>
                        {notification.message}
                    </Noti>
                ))}
            </div>)
            }
            {children}
        </NotificationContext.Provider >
    );
};


export const useNotification = (): NotificationContextType => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};



const SuccessIcon = () => {
    return (<svg
        fill="rgb(3, 161, 0)"
        viewBox="0 0 64 64"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 2
        }}
    >
        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
        <g id="SVGRepo_iconCarrier">
            {" "}
            <rect
                id="Icons"
                x={-512}
                y={-64}
                width={1280}
                height={800}
                style={{ fill: "none" }}
            />{" "}
            <g id="Icons1">
                {" "}
                <g id="Strike"> </g> <g id="H1"> </g> <g id="H2"> </g> <g id="H3"> </g>{" "}
                <g id="list-ul"> </g> <g id="hamburger-1"> </g> <g id="hamburger-2"> </g>{" "}
                <g id="list-ol"> </g> <g id="list-task"> </g> <g id="trash"> </g>{" "}
                <g id="vertical-menu"> </g> <g id="horizontal-menu"> </g>{" "}
                <g id="sidebar-2"> </g> <g id="Pen"> </g>{" "}
                <g id="Pen1">
                    {" "}
                </g>{" "}
                <g id="clock"> </g> <g id="external-link"> </g> <g id="hr"> </g>{" "}
                <path
                    id="success"
                    d="M56.103,16.824l-33.296,33.297l-14.781,-14.78l2.767,-2.767l11.952,11.952l30.53,-30.53c0.943,0.943 1.886,1.886 2.828,2.828Z"
                    style={{ fillRule: "nonzero" }}
                />{" "}
                <g id="info"> </g> <g id="warning"> </g> <g id="plus-circle"> </g>{" "}
                <g id="minus-circle"> </g> <g id="vue"> </g> <g id="cog"> </g>{" "}
                <g id="logo"> </g> <g id="radio-check"> </g> <g id="eye-slash"> </g>{" "}
                <g id="eye"> </g> <g id="toggle-off"> </g> <g id="shredder"> </g>{" "}
                <g id="spinner--loading--dots-" >
                    {" "}
                </g>{" "}
                <g id="react"> </g> <g id="check-selected"> </g> <g id="turn-off"> </g>{" "}
                <g id="code-block"> </g> <g id="user"> </g> <g id="coffee-bean"> </g>{" "}
                <g id="coffee-beans">
                    {" "}
                    <g id="coffee-bean1" >
                        {" "}
                    </g>{" "}
                </g>{" "}
                <g id="coffee-bean-filled"> </g>{" "}
                <g id="coffee-beans-filled">
                    {" "}
                    <g id="coffee-bean2" >
                        {" "}
                    </g>{" "}
                </g>{" "}
                <g id="clipboard"> </g> <g id="clipboard-paste"> </g>{" "}
                <g id="clipboard-copy"> </g> <g id="Layer1"> </g>{" "}
            </g>{" "}
        </g>
    </svg>
    )
}

const ErrorIcon = () => {
    return (<svg
        viewBox="0 0 512 512"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill="rgb(225, 38, 38)"
    >
        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
        <g id="SVGRepo_iconCarrier">
            {" "}
            <title>error</title>{" "}
            <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                {" "}
                <g id="add" fill="rgb(225, 38, 38)" transform="translate(42.666667, 42.666667)">
                    {" "}
                    <path
                        d="M213.333333,3.55271368e-14 C331.136,3.55271368e-14 426.666667,95.5306667 426.666667,213.333333 C426.666667,331.136 331.136,426.666667 213.333333,426.666667 C95.5306667,426.666667 3.55271368e-14,331.136 3.55271368e-14,213.333333 C3.55271368e-14,95.5306667 95.5306667,3.55271368e-14 213.333333,3.55271368e-14 Z M213.333333,42.6666667 C119.232,42.6666667 42.6666667,119.232 42.6666667,213.333333 C42.6666667,307.434667 119.232,384 213.333333,384 C307.434667,384 384,307.434667 384,213.333333 C384,119.232 307.434667,42.6666667 213.333333,42.6666667 Z M262.250667,134.250667 L292.416,164.416 L243.498667,213.333333 L292.416,262.250667 L262.250667,292.416 L213.333333,243.498667 L164.416,292.416 L134.250667,262.250667 L183.168,213.333333 L134.250667,164.416 L164.416,134.250667 L213.333333,183.168 L262.250667,134.250667 Z"
                        id="error"
                    >
                        {" "}
                    </path>{" "}
                </g>{" "}
            </g>{" "}
        </g>
    </svg>
    )
}


const InfoIcon = () => {
    return (<svg
        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
        <g id="SVGRepo_iconCarrier">
            {" "}
            <circle cx={12} cy={12} r={10} stroke="#000000" strokeWidth="1.5" />{" "}
            <path
                d="M12 17V11"
                stroke="#000000"
                strokeWidth="1.5"
                strokeLinecap="round"
            />{" "}
            <circle
                cx={1}
                cy={1}
                r={1}
                transform="matrix(1 0 0 -1 11 9)"
                fill="#000000"
            />{" "}
        </g>
    </svg>

    )
}